export const version = '0.808.0-SNAPSHOT'
export const chameleonWebVersion = '10.5.1'
export const chameleonCoreVersion = '7.14.0'
